<div
  class="absolute w-full lg:w-80 rounded-t-lg border border-color foreground z-40 bottom-0 lg:right-10"
  *ngIf="progress().length"
>
  <div class="text-color flex items-center justify-between py-4 px-4">
    <div>
      <h6 class="text-color">Processos</h6>
      <small class="subtext-color">Operações em andamento!</small>
    </div>

    <button
      lButton
      class="!rounded-full !w-8 !h-8"
      (click)="open = !open"
    >
      <l-icon class="text-xl">
        {{ open ? 'keyboard_arrow_down' : 'keyboard_arrow_up' }}
      </l-icon>
    </button>
  </div>

  <div *ngIf="open" class="px-4 h-px mx-4 bg-lBlue200 hidden lg:block"></div>

  <div class="max-h-80 p-4 h-80 overflow-y-auto" *ngIf="open">
    <div *ngFor="let p of progress()">
      <div class="mb-4 p-4 border-radius border border-color">
        <header class="text-color flex justify-between items-center w-full mb-2">
          {{ p.name }}

          <button
            *ngIf="p.cancel" (click)="cancel(p)" [lDisabled]="p.canceled"
            lButton
            class="!rounded-full !w-8 !h-8"
          >
            <l-icon class="text-1xl">
              close
            </l-icon>
          </button>
        </header>

        <div class="flex items-center justify-center relative h-6 w-full rounded-full">
          <span
            class="absolute z-10 rounded-full left-0 h-6 bg-lWarning"
            [ngStyle]="{ width: (p.loading || p.canceled) ? 0 : (p.current / p.total) * 100 + '%' }"
          ></span>

          <label *ngIf="p.loading && !p.canceled" class="text-color absolute z-20 text-neutral-700">Inicializando...</label>
          <label *ngIf="p.canceled" class="text-color absolute z-20 text-neutral-700">Cancelado...</label>
          <label *ngIf="!p.loading && !p.canceled" class="text-color absolute z-20 text-neutral-700">{{ (p.current + ' de ' + p.total) }}</label>
        </div>
      </div>
    </div>
  </div>
</div>
